import { getAPIErrorString } from "../utils/utils";
import api from "./config/axiosConfig";

export const RatingsAPI = {
  create: async function (body: any) {
    try {
      const response = await api.request({
        url: `/ratings`,
        method: "POST",
        baseURL: process.env.REACT_APP_API_BASE_PATH,
        data: body,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "token-type": localStorage.getItem("token_type"),
        },
      });
      return response.data;
    } catch (e: any) {
      throw getAPIErrorString(e);
    }
  },
  
};
